import Vue from 'vue';
import { isTablet, intersectionObserver } from 'utils/general';
import { trackEvent } from 'lib/tracking';
import {Autoplay, Pagination, A11y, Keyboard} from "swiper/modules";

export default (el) =>
  new Vue({
    components: {
      'vimeo-video-background': () => import('./vimeo-video-background.vue'),
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
    },
    el,
    data: () => ({
      swiper: null,
      swiperOptions: {
        slidesPerView: 1,
        a11y: true,
        keyboard: true,
        autoplay: Number(el.dataset.autoplay) > 0 ? { delay: Number(el.dataset.autoplay) }: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return `<button class="${className}"></button>`;
          },
        },
        modules: [Autoplay, Pagination, A11y, Keyboard],
      },
      isTablet: isTablet(),
    }),
    mounted() {
      if (this.$el.dataset.enableTracking === 'true') {
        this.payload = {
          banner_id: this.$el.dataset.templateId,
          banner_location: this.$el.dataset.module,
        };
      };
      setTimeout(() => {
        this.bannersViewTracking();
      }, 1000);
    },
    methods: {
      bannersViewTracking() {
        if (this.$el.dataset.enableTracking === 'true') {
          const bannerChildren = this.$el.querySelectorAll('[data-hero-item]');
          bannerChildren.forEach(banner => {
            intersectionObserver(banner, () => trackEvent({
                event: 'banner_impression',
                ...this.payload,
                banner_name: banner.dataset.heroItem !== "" ? banner.dataset.heroItem : undefined,
                shopify_module_name: 'hero slider'
            }));
          });
        };
      },
      clickTracking(url, banner_name = undefined) {
        if (this.$el.dataset.enableTracking === 'true') {
          trackEvent({
            event: 'banner_click',
            ...this.payload,
            banner_name,
            eventCallback: () => {
              document.location = url;
            },
            eventTimeout: 2000,
            shopify_module_name: 'hero slider'
          });
        } else window.location.href = url;
      }
    },
  });
